<template>
  <h1>{{ $attrs.value }}</h1>
</template>

<script>
export default {
  name: "BlockTitle"
}
</script>

<style scoped>

</style>
